import { ReactComponent } from "./arrow-left-fill.svg";

interface Props {
  fill?: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
}

const ArrowLeftFillIcon: React.FC<Props> = (props) => (
  <ReactComponent {...props} />
);

export default ArrowLeftFillIcon;
